import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresListaGrupoComponent {
  constructor() {
    this.expandirInactivos = false
    this.departamento = undefined
    this.colaboradores = undefined
  }

  $onChanges(changes) {
    if (changes.colaboradores) {
      this.activos = this.colaboradores.filter((item) => item.estatus === 'Activo')
      this.inactivos = this.colaboradores.filter((item) => item.estatus === 'Inactivo')
      this.expandirInactivos = this.activos.length === 0
    }
  }
}

module.component('fanProyectoColaboradoresListaGrupo', {
  controller: FanProyectoColaboradoresListaGrupoComponent,
  template: template,
  bindings: {
    departamento: '<',
    colaboradores: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/lista/grupo/component.js